import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface CenteredDismissModalProps {
	title?: string | null;
	content: string | JSX.Element | JSX.Element[];
	handleDismiss: () => void;
	dismissText?: string;
	contentStyle?: React.CSSProperties;
	titleStyle?: React.CSSProperties;
	width?: string | number;
	maxWidth?: string | number;
	contentMaxHeight?: string | number;
}

const defaultContentStyle: React.CSSProperties = {
	display: 'flex',
	flexDirection: 'column',
	padding: '20px 0',
	margin: '0 auto',
	overflowY: 'auto',
	wordBreak: 'break-word',
};

const defaultTitleStyle: React.CSSProperties = {
	fontWeight: 'bold',
	textAlign: 'center',
};

export const CenteredDismissModal = ({
	title = '',
	content,
	handleDismiss,
	dismissText = 'Close',
	contentStyle = defaultContentStyle,
	titleStyle = defaultTitleStyle,
	width = '600px',
	maxWidth = '90vw',
	contentMaxHeight = '60vh',
}: CenteredDismissModalProps): JSX.Element => (
	<div style={{ width, maxWidth }}>
		{title ? (
			<Typography data-cy='modal-title-text' style={titleStyle} variant='h6'>
				{title}
			</Typography>
		) : null}

		<div
			style={{
				...contentStyle,
				maxHeight: contentMaxHeight,
			}}
			data-cy='modal-body-text'
		>
			{content}
		</div>

		<Grid container justifyContent='center'>
			<Grid item xs={12} sm={6}>
				<Button fullWidth onClick={handleDismiss} data-cy='modal-dismiss-button'>
					{dismissText}
				</Button>
			</Grid>
		</Grid>
	</div>
);
